import { Component, Input } from '@angular/core';
import { AppDataService, ConfigService } from 'app/services';
import { AppComponent } from 'app/app.component';

export enum PartnerAppConfigMenuEnum {
    Branding = 1,
    Products = 2,
    Categories = 3
}

@Component({
    selector: 'partner-appconfig-root',
    templateUrl: './partner-appconfig-root.component.html',
    styleUrls: ['./partner-appconfig-root.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class PartnerAppconfigRootComponent {
    constructor(private appData: AppDataService, public configService: ConfigService,
        public app: AppComponent) { }

    @Input()
    public menuPermissionActive!: string;

    public partnerAppConfigMenuEnum = PartnerAppConfigMenuEnum;
    public activePartnerAppConfigMenu: PartnerAppConfigMenuEnum = PartnerAppConfigMenuEnum.Branding;

    public onMenuClick(menuLink: PartnerAppConfigMenuEnum) {
        this.activePartnerAppConfigMenu = menuLink;
    }
}
